<div class="hidden cursor-pointer grid-cols-4 gap-8 lg:grid">
    @for (image of desktopImages(); track image) {
        @if ($last) {
            <div class="relative">
                <div class="bg-black-70 absolute z-10 flex h-full w-full items-center justify-center">
                    <button
                        class="border-accent text-accent flex items-center gap-3 border-1 bg-white px-6 py-3 font-medium"
                        (click)="openVehicleGalleryOverlay(0)"
                    >
                        <i class="icon-image"></i>
                        <span>{{ images().length }} Bilder</span>
                    </button>
                </div>
                <ui-m000-c010-image
                    class="bg-grey-500 image-hover block h-full"
                    [image]="{
                        image: image,
                        desktop: { width: 165, height: 107 },
                        tablet: { width: 165, height: 107 },
                        mobile: { width: 165, height: 107 },
                    }"
                    [priority]="isFirstView()"
                    classList="h-full w-full aspect-[767/202] md:aspect-[975/257] lg:aspect-[165/107] object-cover"
                    alt=""
                />
            </div>
        } @else {
            <div (click)="openVehicleGalleryOverlay($index)">
                <ui-m000-c010-image
                    class="bg-grey-500 image-hover block h-full"
                    [image]="{
                        image: image,
                        desktop: { width: 165, height: 107 },
                        tablet: { width: 165, height: 107 },
                        mobile: { width: 165, height: 107 },
                    }"
                    [priority]="isFirstView()"
                    classList="h-full w-full aspect-[165/107]"
                    alt=""
                    cover
                />
            </div>
        }
    }
</div>
<div class="lg:hidden">
    <button
        class="border-accent text-accent flex items-center gap-4 border-2 bg-white px-8 py-4 font-bold"
        (click)="openVehicleGalleryOverlay(0)"
    >
        <i class="icon-image text-18"></i>
        <span>{{ images().length }} Bilder</span>
    </button>
</div>
